var logoCarousel = $('.logo-list-carousel');
logoCarousel.owlCarousel({
    rtl: true,
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    responsive:{
      0: {
        items: 1
      },
      600: {
        items: 3
      },
      1000: {
        items: 5
      }
    }
})

// Go to the next item
$('.owl-next').click(function() {
    logoCarousel.trigger('next.owl.carousel');
})
// Go to the previous item
$('.owl-prev').click(function() {
    // With optional speed parameter
    // Parameters has to be in square bracket '[]'
    logoCarousel.trigger('prev.owl.carousel', [300]);
})


/*** available on request ***/
if ($("body").hasClass("template-product")) {
  var selectedVariant = $(".original-selector").find(':selected');
  toggleUponRequest(selectedVariant);
  
  $(".product-purchase-form").on('change', '.original-selector', function(){
    var selectedVariant = $(this).find(':selected');
    toggleUponRequest(selectedVariant);
  });
}

function toggleUponRequest(selectedVariant) {
  var inventoryPolicy = selectedVariant.data("inventory-policy");
  var inventoryQuantity = selectedVariant.data("inventory-quantity");
  
  console.log(inventoryPolicy, inventoryQuantity);

  if(inventoryPolicy == "continue" && inventoryQuantity < 1) {
    $(".available").hide();
    $(".unavailable").hide();
    $(".available-on-request").show();
  }
  else if (inventoryQuantity > 0) {
    $(".available-on-request").hide();
    $(".unavailable").hide();
    $(".available").show();
  }
  else {
    $(".available-on-request").hide();
    $(".available").hide();
    $(".unavailable").show();
  }
}

/*** available on request ***/

// espa banners
var locale = Shopify.locale;
var espa = {
  el: {banner: "https://cdn.shopify.com/s/files/1/0559/8822/4150/files/espa-banner-el.jpg?v=1641928993", poster: "https://cdn.shopify.com/s/files/1/0559/8822/4150/files/espa-afisa-el.pdf?v=1641929910"},
  en: {banner: "https://cdn.shopify.com/s/files/1/0559/8822/4150/files/espa-banner-en.jpg?v=1641928972", poster: "https://cdn.shopify.com/s/files/1/0559/8822/4150/files/espa-afisa-en.pdf?v=1641930430"}
}

$(".espa-banner-wrapper, .espa-banner-wrapper-desktop").html("<a target='_blank' href='" + espa[locale].poster + "'><img src='" + espa[locale].banner + "' alt='Espa Banner' /></a>");

// espa banners
